import axios from 'axios';
import csrfToken from '../../../shared/meta';
import axiosConfig from '../../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axiosConfig });

export function useGetCompanies() {
  return useAxios({
    cache: { ignoreCache: true },
    url: '/api/v1/lwadmin/companies',
    method: 'GET',
  }, { manual: true });
}

const snakeCaseCompany = c => ({
  name: c.name,
  administrator_email: c.administratorEmail,
  website_url: c.websiteUrl,
  logo_color: c.logoColor,
  summary: c.summary,
  member_ids: (c.members || []).map(m => m.id),
});

export function createCompany(payload) {
  return axios.post('/api/v1/lwadmin/company', {
    authenticity_token: Livewire.formAuthenticityToken,
    ...snakeCaseCompany(payload),
  });
}

export function updateCompany(payload) {
  return axios.put(`/api/v1/lwadmin/company/${payload.id}`, {
    authenticity_token: Livewire.formAuthenticityToken,
    ...snakeCaseCompany(payload),
  });
}

export function usePutUpdateCompany(id) {
  const [state, q] = useAxios({
    url: `/api/v1/lwadmin/company/${id}`,
    headers: { 'X-CSRF-TOKEN': csrfToken() },
    method: 'PUT',
  }, { manual: true });
  const executeQuery = payload => q({
    url: `/api/v1/lwadmin/company/${payload.id}`,
    data: snakeCaseCompany(payload),
  });
  return [state, executeQuery];
}

const fileToFormData = (file, name) => {
  const data = new FormData();
  file && data.append('logo_picture', file, name || 'logo.png');
  return data;
};

export function usePostUploadLogoPicture(companyId) {
  const [state, q] = useAxios({
    url: `/api/v1/lwadmin/company/${companyId}/_update_logo_picture`,
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
  }, { manual: true });
  const executeQuery = (id, file, name) => q({
    url: `/api/v1/lwadmin/company/${id}/_update_logo_picture`,
    data: fileToFormData(file, name),
  });
  return [state, executeQuery];
}

export function usePostRemoveLogoPicture(companyId) {
  const [state, q] = useAxios({
    url: `/api/v1/lwadmin/company/${companyId}/_remove_logo_picture`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = id => q({ url: `/api/v1/lwadmin/company/${id}/_remove_logo_picture` });
  return [state, executeQuery];
}

export function createCompanyCTA(companyId, cta) {
  return axios.post(`/api/v1/lwadmin/company/${companyId}/cta`, {
    authenticity_token: Livewire.formAuthenticityToken,
    cta,
  });
}

export function updateCompanyCTA(companyId, cta) {
  return axios.put(`/api/v1/lwadmin/company/${companyId}/cta/${cta.id}`, {
    authenticity_token: Livewire.formAuthenticityToken,
    cta,
  });
}
